// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_gh-0";
export var headerCellHover = "_gh-1";
export var readCellContainer = "_gh-2";
export var unreadIndicator = "_gh-3";